
// nastaveni pozic symbolu na valcich
import {
    server_config,
    reels_pos,
    behavior_config,
    reels_lenghts,
    server_result,
    ico_he
} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_forcestopnow} from "../framework/src/engine/madnes/madnes";
import {cylinder_pos, icons_tmp, last_symbol, smybols_offset_top, symbols} from "./ps_config";
import {madnes_get_pos_y, madnes_set_pos_y} from "../framework/src/engine/madnes/madnes_object";
import {rotate_stop, stopposin, stopposin_old} from "./ps_core";

export function print_reels()
{
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        print_reel(i, reels_pos[i]);
    }
}

// nastaveni pozic symbolu na valci
function print_reel(reel, pos)
{
    if(
        reel == 0 &&
        (
            symbols[reel] >= (behavior_config.reel.spin.duration - 2) ||
            madnes_forcestopnow()
        ) &&
        server_result != null &&
        stopposin[0] == -1 &&
        /*&& madnes_get_pos_y("reels_bufer_" + (cylinder_pos.length - 1) + "_S2") < 0*/
        madnes_get_pos_y("reels_bufer_" + 0 + "_S1") < 0
    )
    {
        rotate_stop();
    }

    while(pos * 1 >= ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he)
    {
        pos -= ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he;
    }

    while(pos * 1 < 0)
    {
        pos += ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he;
    }

    icons_tmp[2] = Math.floor(pos / ico_he);

    if(server_config.logic.reels[reel][icons_tmp[2]] == null || typeof server_config.logic.reels[reel][icons_tmp[2]] == "undefined")
    {
        icons_tmp[2] = 0;
    }

    icons_tmp[0] = icons_tmp[2]+2;
    icons_tmp[1] = icons_tmp[2]+1;
    icons_tmp[3] = icons_tmp[2]-1;
    icons_tmp[4] = icons_tmp[2]-2;

    if(!isNaN(icons_tmp[2]) && last_symbol[reel] != icons_tmp[2])
    {
        last_symbol[reel] = icons_tmp[2];
        symbols[reel]++;
    }

    var t0 = pos - (ico_he * icons_tmp[2]) + smybols_offset_top - ico_he;

    if(isNaN(t0))
    {
        return;
    }

    for(var i = 0; i <= 4; i++)
    {
        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] >= reels_lenghts[reel]
            )
        {
            icons_tmp[i] = icons_tmp[i] * 1 - reels_lenghts[reel] * 1;
        }

        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] < 0
            )
        {
            icons_tmp[i] = reels_lenghts[reel] * 1 + icons_tmp[i] * 1;
        }
    }

    var stop_tmp = stopposin_old;
    if(stop_tmp[reel] == null || stop_tmp[reel] == -1)
    {
        stop_tmp = stopposin;
    }

    if(stop_tmp[reel] != null && stop_tmp[reel] != -1)
    {
        for(var ii = 0; ii < icons_tmp.length; ii++)
        {
            if(
                icons_tmp[ii] >= ( stop_tmp[reel] % reels_lenghts[reel] ) - 1 &&
                icons_tmp[ii] <= ( stop_tmp[reel] % reels_lenghts[reel] ) + 1
            )
            {
                icons_tmp[ii] = "S" + ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 );
            }
            else if(
                stop_tmp[reel] % reels_lenghts[reel] == 0 &&
                icons_tmp[ii] + 1 >= reels_lenghts[reel]
            )
            {
                icons_tmp[ii] = "S" + ( ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 ) % reels_lenghts[reel] );
            }
            else if(
                stop_tmp[reel] % reels_lenghts[reel] == reels_lenghts[reel] - 1 &&
                icons_tmp[ii] == 0
            )
            {
                icons_tmp[ii] = "S" + ( ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 ) % reels_lenghts[reel] + reels_lenghts[reel] );
            }
        }
    }

    for(var i = 0; i <= 4; i++)
    {
        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] >= reels_lenghts[reel]
            )
        {
            icons_tmp[i] = icons_tmp[i] * 1 - reels_lenghts[reel] * 1;
        }

        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] < 0
            )
        {
            icons_tmp[i] = reels_lenghts[reel] * 1 + icons_tmp[i] * 1;
        }

    }

    for(var i = 0; i < reels_lenghts[reel]; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_" + i, -9999);
        //madnes_set_pos_y("text_reels_bufer_" + reel + "_" + i, -9999);
    }

    /*for(var i = 0; i <= 2; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_TMP" + i, -9999);
    }*/

    for(var i = 0; i <= 2; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_S" + i, -9999);
        //madnes_set_pos_y("text_reels_bufer_" + reel + "_S" + i, -9999);
    }

    for(var i = 0; i <= 4; i++)
    {
        //console.log(icons_tmp[i]);

        madnes_set_pos_y("reels_bufer_"+reel+"_"+icons_tmp[i], (t0 + ( ico_he * i )) | 0 );
        //madnes_set_pos_y("text_reels_bufer_"+reel+"_"+icons_tmp[i], t0 + ( ico_he * i ));
    }

    /*var cs = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        cs = behavior_config.reel.spin.freeSpinSpeed;
    }

    var yAnimPlayFrom = ((ico_he * cs / (1000 / 33)) | 0) * 2;

    if(!(rotated == 1 || all_set_for_stop == 0))
    {
        if(madnes_get_pos_y("reels_bufer_"+reel+"_S0") >= 432 - 0 && !stop_anim_played[reel])
        {
            stop_anim_played[reel] = true;

            madnes_anim_play("reels_bufer_"+reel+"_S0", "land", 30);
            madnes_anim_play("reels_bufer_"+reel+"_S1", "land", 30);
            madnes_anim_play("reels_bufer_"+reel+"_S2", "land", 30);
        }
    }

    if(madnes_get_pos_y("reels_bufer_"+0+"_S0") >= 432)
        console.log(madnes_get_pos_y("reels_bufer_"+0+"_S0"));
    */
}
